import React, { FC } from 'react'
import { AccommodationInformation, ScrollDimModal } from '~/app/components'
import { useRouter } from 'next/router'
import { DateTime } from 'luxon'
import { useRerender } from '~/app/components/common/ForceRerenderProvider'
import { ApolloError } from '@apollo/client'
import { AccommodationInfo } from './AccommodationInformation'

/**
 * AccommodationInformationModal component
 * author: soojin.oh
 */

type Props = {
  isOpened: boolean
  accommodationInfo?: AccommodationInfo | null
  getAccommodationDetails: () => void
  error?: ApolloError
  categoryOrderId: string
}

// styled components
const TARGET_ID = 'accommodation-information'
// AccommodationInformationModal component
const AccommodationInformationModal: FC<Props> = function ({
  error,
  isOpened,
  accommodationInfo,
  getAccommodationDetails,
  categoryOrderId,
}) {
  const { back, query } = useRouter()
  const { rerender } = useRerender()
  const [checkIn, checkOut] = [query.checkIn as string, query.checkOut as string]
    .map(decodeURIComponent)
    .map(str => DateTime.fromISO(str))
    .map(date => date.toFormat('yyyy-MM-dd'))
  const cancelPolicyId = query.cancel as string

  return (
    <ScrollDimModal isOpened={isOpened} targetId={TARGET_ID}>
      <AccommodationInformation
        checkIn={checkIn}
        checkOut={checkOut}
        cancelPolicyId={cancelPolicyId}
        response={accommodationInfo}
        getAccommodationDetails={getAccommodationDetails}
        categoryOrderId={categoryOrderId}
        error={error}
        onBackClick={() => {
          back()
          rerender()
        }}
      />
    </ScrollDimModal>
  )
}

export default AccommodationInformationModal
